import React from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  Bar,
  Cell,
  Line,
} from "recharts";
import { Skeleton } from "@mui/material";
import { tokens, fmtNumber } from "../../shared/clinical-design";

const tick = { fontFamily: tokens.fontMono, fontSize: 11, fill: tokens.ink3 };

const monthLabel = (m) =>
  new Date(`${m}-02T00:00:00`).toLocaleString("en-US", { month: "short" });

/**
 * Tendencia de membresía 12 meses: línea = miembros totales,
 * barras = cambio neto mensual (ok/crit según signo). Sobrio, sin gradientes.
 *
 * @param {Object[]} data - [{ month, members, net }]
 * @param {boolean} [loading]
 */
export default function MembershipTrendChart({ data = [], loading = false }) {
  if (loading) return <Skeleton variant="rectangular" height={250} />;

  const rows = data.map((d) => ({ ...d, label: monthLabel(d.month) }));

  return (
    <ResponsiveContainer width="100%" height={250}>
      <ComposedChart data={rows} margin={{ top: 8, right: 4, left: 0, bottom: 0 }}>
        <CartesianGrid stroke={tokens.line} vertical={false} />
        <XAxis dataKey="label" tick={tick} tickLine={false} axisLine={{ stroke: tokens.lineStrong }} />
        <YAxis
          yAxisId="members"
          domain={["dataMin - 200", "dataMax + 200"]}
          tick={tick}
          width={52}
          tickLine={false}
          axisLine={false}
          tickFormatter={fmtNumber}
        />
        <YAxis yAxisId="net" orientation="right" tick={tick} width={44} tickLine={false} axisLine={false} />
        <Tooltip
          contentStyle={{
            fontFamily: tokens.fontUI,
            fontSize: 12,
            border: `1px solid ${tokens.line}`,
            borderRadius: 4,
          }}
          formatter={(value, name) => [fmtNumber(value), name]}
        />
        <ReferenceLine yAxisId="net" y={0} stroke={tokens.lineStrong} />
        <Bar yAxisId="net" dataKey="net" name="Net change" barSize={14}>
          {rows.map((d) => (
            <Cell key={d.month} fill={d.net >= 0 ? tokens.ok : tokens.crit} fillOpacity={0.5} />
          ))}
        </Bar>
        <Line
          yAxisId="members"
          type="monotone"
          dataKey="members"
          name="Members"
          stroke={tokens.primary}
          strokeWidth={2}
          dot={{ r: 2.5, fill: tokens.primary }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
